import { onScrollChange } from '@analytics/scroll-utils';
import { onAnalyticsUnload, track } from '../analytics/index.esm.js';
import { WebsiteEvents } from '../constants/events.esm.js';

const defaultScrollOptions = {
    thresholds: [
        10,
        25,
        50,
        75,
        90
    ]
};
const handler = (payload)=>{
    track(WebsiteEvents.SCROLL, {
        scroll_depth: payload.trigger
    });
};
/**
 * This tracker is used to track scroll events.
 * It's dispatched when the user scrolls the page to the certain percentage of the page height.
 * The percentage is configurable via options.thresholds.
 */ const scrollEventTracker = (options)=>{
    options = {
        ...defaultScrollOptions,
        ...options
    };
    const handlers = {};
    options.thresholds.forEach((percent)=>{
        handlers[percent] = handler;
    });
    const removeScrollListener = onScrollChange(handlers);
    onAnalyticsUnload(removeScrollListener);
};

export { scrollEventTracker };
